
import { defineComponent, ref, onMounted } from "@vue/composition-api";

import BarCode from "@/components/settings/BarCode.vue";

export default defineComponent({
  name: "MfaForm",
  components: { BarCode },
  setup(_, context) {
    const preferred = ref("NOMFA");

    const code = ref("");
    const answer = ref("");

    const reload = () =>
      Promise.resolve()
        .then(() => context.root.$auth.raw.currentUserPoolUser())
        .then(user => (preferred.value = user.preferredMFA));

    const setUp = () =>
      Promise.resolve()
        .then(() => context.root.$auth.raw.currentUserPoolUser())
        .then(user =>
          Promise.resolve()
            .then(() => context.root.$auth.raw.setupTOTP(user))
            .then(
              code =>
                `otpauth://totp/Verbotics AI:${
                  user.attributes.email
                }?secret=${code}&issuer=Verbotics`
            )
            .then(value => (code.value = value))
        );

    const verify = () =>
      Promise.resolve()
        .then(() => context.root.$auth.raw.currentUserPoolUser())
        .then(user =>
          Promise.resolve()
            .then(() =>
              context.root.$auth.raw.verifyTotpToken(user, answer.value)
            )
            .then(() => context.root.$auth.raw.setPreferredMFA(user, "TOTP"))
            .then(() => reload())
        )
        .catch(err => {
          console.log(err);
        });

    const deactivate = () =>
      Promise.resolve()
        .then(() =>
          window.confirm(
            "Are you sure you want to disable multi-factor authentication?\n\nYour licence agreement may prohibit you from disabling multi-factor authentication on this account. Please check with your organization if you still intend to disable it."
          )
            ? Promise.resolve()
            : Promise.reject()
        )
        .then(() => context.root.$auth.raw.currentUserPoolUser())
        .then(user => context.root.$auth.raw.setPreferredMFA(user, "NOMFA"))
        .then(() => reload());

    onMounted(() => reload());

    return { preferred, code, answer, setUp, verify, deactivate };
  }
});
